import * as t from "io-ts";
import { Archived } from "./Archived";
import { BaseId } from "./BaseId";
import { EnquiryInfo } from "./EnquiryInfo";
import { EnquiryState } from "./EnquiryState";

export const Enquiry = t.intersection([
  BaseId,
  t.intersection([
    t.type({
      name: t.string,
      source: t.string,
      current_state: EnquiryState,
      states: t.array(EnquiryState),
      archived: Archived,
    }),
    t.partial({
      enquiry_info: EnquiryInfo,
    }),
  ]),
]);

export type Enquiry = BaseId & {
  name: string;
  source: string;
  enquiry_info?: EnquiryInfo;
  current_state: EnquiryState;
  states: Array<EnquiryState>;
  archived: Archived;
};
